import React from 'react';
import { Card, CardContent } from '../ui/card';

const BENEFITS = [
  { emoji: '⏱️', text: '30 minutes to bottle your wine' },
  { emoji: '🍷', text: 'Each kit makes 30 750-ml bottles' },
  { emoji: '📊', text: 'Alcohol content ranges from 8-13%' },
];

const HomeWelcome = () => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Previously known as Kawartha Lakes Winery
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          We are super proud to continue to share with you just how fun, easy, and cost-effective it is to make your own wine.
          With many wines to choose from, there is something for every palate. We offer dry and off-dry whites, robust red wines,
          fruit wines that are perfect for summer, and flavoured ports for the holidays.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          Or, you can always take advantage of our amazing Ciders.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {BENEFITS.map((b) => (
            <Card key={b.text} className="border-[#FDB913]/30 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="text-4xl mb-4">{b.emoji}</div>
                <p className="font-semibold text-gray-900">{b.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-sm text-gray-600 italic mt-8">
          Our wine kits also contain very little sulphite, a preservative and potential allergen found in commercial wines.
        </p>
      </div>
    </div>
  </section>
);

export default HomeWelcome;
